<template>
  <section class="process section">
    <div class="container">
      <div class="section-header">
        <span class="section-label">项目建设路径</span>
        <h2 class="section-title">从业务梳理到持续运营，让AI真正进入政务流程</h2>
        <p class="section-desc">
          政务智能化不是简单接入一个模型，而是围绕现有制度、数据边界、岗位分工和审批流程重构能力。
          小智科技以"业务可解释、数据可追溯、系统可运维"为建设原则，帮助客户把AI能力落到日常工作环节中。
        </p>
      </div>

      <div class="process__grid">
        <div
          v-for="step in processSteps"
          :key="step.step"
          class="process__card"
        >
          <div class="process__step">{{ step.step }}</div>
          <h3 class="process__title">{{ step.title }}</h3>
          <p class="process__desc">{{ step.desc }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { processSteps } from '../data/site'

export default {
  name: 'ProcessSection',
  data() {
    return { processSteps }
  }
}
</script>

<style scoped>
.process {
  background: #f7f9fc;
}

.process__grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;
}

.process__card {
  background: #fff;
  border-radius: 12px;
  padding: 32px 24px;
  border: 1px solid #eef1f6;
  transition: box-shadow 0.3s, transform 0.3s;
}

.process__card:hover {
  box-shadow: 0 8px 32px rgba(0, 82, 217, 0.1);
  transform: translateY(-4px);
}

.process__step {
  font-size: 36px;
  font-weight: 800;
  color: #0052d9;
  opacity: 0.15;
  line-height: 1;
  margin-bottom: 16px;
}

.process__title {
  font-size: 18px;
  font-weight: 700;
  color: #1a1a2e;
  margin-bottom: 12px;
}

.process__desc {
  font-size: 14px;
  color: #666;
  line-height: 1.7;
}

@media (max-width: 960px) {
  .process__grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 560px) {
  .process__grid {
    grid-template-columns: 1fr;
  }
}
</style>
